var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFootprint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 277.59 224.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1 {\r\n        fill: #333;\r\n        stroke-width: 0px;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\xEB\\xEE\\xE9_1",
    "data-name": "\\u2018\\xEB\\xEE\\xE9_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m130.42,224.27H20.84c-2.09,0-3.79-1.7-3.79-3.79V41.37c0-1.62,1.03-3.06,2.56-3.59L129.19.21c1.15-.4,2.44-.21,3.43.5.99.71,1.59,1.86,1.59,3.09v216.68c0,2.09-1.7,3.79-3.79,3.79Zm-105.79-7.58h102V9.1L24.63,44.08v172.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m216.8,224.27h-86.38c-2.09,0-3.79-1.7-3.79-3.79V41.37c0-1.2.57-2.33,1.53-3.05.96-.72,2.21-.93,3.36-.59l86.38,26.06c1.6.48,2.7,1.96,2.7,3.63v153.05c0,2.09-1.7,3.79-3.79,3.79Zm-82.59-7.58h78.8V70.25l-78.8-23.77v170.21Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m273.8,224.27H3.79c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h270c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m248.09,224.27c-2.09,0-3.79-1.7-3.79-3.79v-29.73c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v29.73c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m248.09,194.54c-9.33,0-15.82-11.67-15.82-22.15s6.51-17.25,15.82-17.25,15.83,7.1,15.83,17.25-6.5,22.15-15.83,22.15Zm0-31.82c-5.16,0-8.24,3.61-8.24,9.67,0,7.08,4.24,14.56,8.24,14.56s8.24-7.48,8.24-14.56c0-6.05-3.08-9.67-8.24-9.67Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.57,65.65c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.1,65.65c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.63,65.65c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.16,65.65c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.69,65.65c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.02,83.46h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.02,104.89h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.02,126.32h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.02,147.75h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.02,169.17h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m177.35,83.46h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m177.35,104.89h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m177.35,126.32h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m177.35,147.75h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m177.35,169.17h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.69,83.46h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.69,104.89h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.69,126.32h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.69,147.75h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.69,169.17h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.02,190.6h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m177.35,190.6h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m155.69,190.6h-7.66c-2.09,0-3.79-1.7-3.79-3.79s1.7-3.79,3.79-3.79h7.66c2.09,0,3.79,1.7,3.79,3.79s-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.57,90.64c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.1,90.64c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.63,90.64c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.16,90.64c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.69,90.64c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.57,115.63c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.1,115.63c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.63,115.63c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.16,115.63c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.69,115.63c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.57,140.62c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.1,140.62c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.63,140.62c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.16,140.62c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.69,140.62c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.57,165.61c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.1,165.61c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.63,165.61c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.16,165.61c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.69,165.61c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m38.57,190.6c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m57.1,190.6c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m75.63,190.6c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m94.16,190.6c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.69,190.6c-2.09,0-3.79-1.7-3.79-3.79v-7.45c0-2.09,1.7-3.79,3.79-3.79s3.79,1.7,3.79,3.79v7.45c0,2.09-1.7,3.79-3.79,3.79Z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m112.69,224.27c-2.09,0-3.79-1.7-3.79-3.79v-12.14H42.37v12.14c0,2.09-1.7,3.79-3.79,3.79s-3.79-1.7-3.79-3.79v-15.94c0-2.09,1.7-3.79,3.79-3.79h74.12c2.09,0,3.79,1.7,3.79,3.79v15.94c0,2.09-1.7,3.79-3.79,3.79Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m199.02,224.27c-2.09,0-3.79-1.7-3.79-3.79v-12.14h-43.42v12.14c0,2.09-1.7,3.79-3.79,3.79s-3.79-1.7-3.79-3.79v-15.94c0-2.09,1.7-3.79,3.79-3.79h51c2.09,0,3.79,1.7,3.79,3.79v15.94c0,2.09-1.7,3.79-3.79,3.79Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFootprint);
export default __webpack_public_path__ + "static/media/footprint.02a1605169364f991749de6eb94b944e.svg";
export { ForwardRef as ReactComponent };